module.exports = __webpack_public_path__ + "media/images/wayfinding-wall-mockup-4d62cd162de389203a122fc9d88bb71c.jpg";